var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terminal-nav"},[_c('nav',{staticClass:"terminal-menu"},[_c('ul',{staticClass:"footer"},_vm._l((_vm.links),function(link){return _c('li',{key:link.name},[_c('a',{staticClass:"menu-item",attrs:{"href":link.href,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" "+_vm._s(link.name)+" ")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }